import { FillInTableError } from "../fillInTableError";

// draft article info(/des/draft-article/info) 가 없어 Fill In Table을 구성할 수 없는 경우.
// (예: Not for AI Entry 라 아직 draft article info가 생성되지 않은 케이스)
// 페이지 크래시 대신 FillInTableErrorBoundary 에서 graceful 하게 처리한다.
export class ArticleInfoNotDefinedError extends FillInTableError {
  constructor(message = "articleInfo is not defined") {
    super(message);
  }
}
